import Transcript from './Transcript';
export function isTranscript(track) {
    return track instanceof Transcript;
}
export default isTranscript;    //# sourceMappingURL=isTranscript.js.map
